import { applyMiddleware, createStore, compose } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "../reducers";
import sagas from "../sagas";

const ConfigureStore = () => {
  let composeEnhancers = compose;

  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    rootReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  sagaMiddleware.run(sagas);

  return {
    store,
  };
};

export default ConfigureStore;
